import ThrowsValidationError from "common/http/throwsValidationError";
import SystemUser from "./systemUser";
import HttpService from "common/http/httpService";

class SystemUserService extends HttpService {

    async listSystemUsers(): Promise<SystemUser[]> {
        const response = await this.getClient().get<SystemUser[]>('/settings/v1/system-users');
        return response.data;
    }

    @ThrowsValidationError()
    async createSystemUser(email: string): Promise<SystemUser> {
        const response = await this.getClient().post<SystemUser>('/settings/v1/system-users', {
            email
        });
        return response.data;
    }

    async changeIdentityType(userId: string, isDeveloper: boolean) {
        await this.getClient().put(`/settings/v1/system-users/${userId}/identity-type`, {
            isDeveloper
        });
    }
}

const systemUserService = new SystemUserService();

export default systemUserService;